import p5 from "p5";

let oscillationScalar = 12;


class Particle {



    constructor(x, y, i, sketch) {

        this.sketch = sketch;

        this.fillColor = this.sketch.color("#DDDDDD");
        this.opacity = 100; // 25

        this.isFixed = false;
        this.isFixedX = false;
        this.isFixedY = false;

        this.fixedFrameStart = null;
        this.fixedFrameEnd = null;

        this.circleSize = 3;
        this.sx = this.circleSize;
        this.sy = this.circleSize;

        this.visibleFrameCount = 0;
        this.isVisible = false;


        this.isOscillationX = false;
        this.isOscillationY = false;
        this.oscillationXFrameCount = 0;
        this.oscillationYFrameCount = 0;
        this.oscillationXValue = 0;
        this.oscillationYValue = 0;


        this.randomValue = 0;


        this.internalFrameCount = 0;
        this.internalFrameCountX = 0;
        this.internalFrameCountY = 0;



        this.translateX = 0;
        this.translateY = 0;
        this.ox = x;
        this.oy = y;
        this.index = i;

        this.cx = x;
        this.cy = y;


    }

    reset() {

        this.fillColor = this.sketch.color("#DDDDDD");
        this.opacity = 100; // 25

        this.isFixed = false;
        this.isFixedX = false;
        this.isFixedY = false;

        this.fixedFrameStart = null;
        this.fixedFrameEnd = null;

        this.circleSize = 3;
        this.sx = this.circleSize;
        this.sy = this.circleSize;

        this.visibleFrameCount = 0;
        this.isVisible = false;


        this.isOscillationX = false;
        this.isOscillationY = false;
        this.oscillationXFrameCount = 0;
        this.oscillationYFrameCount = 0;
        this.oscillationXValue = 0;
        this.oscillationYValue = 0;


        this.randomValue = 0;


        this.internalFrameCount = 0;
        this.internalFrameCountX = 0;
        this.internalFrameCountY = 0;



        this.translateX = 0;
        this.translateY = 0;

        this.cx = this.ox;
        this.cy = this.oy;

    }

    update() {
        let rx = Math.sin((this.sketch.frameCount - this.index * 10) / 10.0) * 2;
        let ry = Math.sin((this.sketch.frameCount - this.index * 10) / 10.0) * 2;
        this.cx = this.ox + rx;
        this.cy = this.oy + ry;
    }

    fixPositionX(f) {
        this.isFixedX = f;
    }


    fixPositionY(f) {
        this.isFixedY = f;

    }

    fixPosition(f) {


        this.isFixed = f;

        this.isFixedX = f;
        this.isFixedY = f;

    }


    updateInternalFrameCount() {

        if (this.isFixed == false) {

            this.internalFrameCount += 1;

        }

        if (this.isFixedX == false) {

            this.internalFrameCountX += 1;
        }

        if (this.isFixedY == false) {

            this.internalFrameCountY += 1;

        }

    }

    generateRandomValue(min, max) {

        this.randomValue = min + Math.random() * (max - min);

    }


    resetOscillationFrameCount(f) {

        this.oscillationXFrameCount = f;
        this.oscillationYFrameCount = f;
    }

    updateOscillationXFrameCount(f) {
        if (!this.isOscillationX) {
            this.oscillationXFrameCount = f;
            this.isOscillationX = true;
        }
    }

    updateOscillationYFrameCount(f) {
        if (!this.isOscillationY) {
            this.oscillationYFrameCount = f;
            this.isOscillationY = true;
        }
    }

    updateVisibleFrameCount(f) {

        if (!this.isVisible) {
            this.visibleFrameCount = f;
            this.isVisible = true;
        }
    }



    updatePosition(rx, ry) {

        if (!this.isFixedX) this.cx = this.ox + rx;

        if (!this.isFixedY) this.cy = this.oy + ry;


    }

    updateOscillationPosition() {

        let rx = 0;
        let ry = 0;
        if (this.isOscillationX && !this.isFixedX) {
            //rx = sin((frameCount - oscillationXFrameCount - index*10) / 20.0) * (oscillationXValue * oscillationScalar);
            rx = Math.sin((this.internalFrameCountX - this.oscillationXFrameCount - this.index * 10) / 20.0) * (this.oscillationXValue * oscillationScalar);
        }

        if (this.isOscillationY && !this.isFixedY) {
            //ry = sin((frameCount - oscillationYFrameCount - index*30) / 20.0) * (oscillationYValue * oscillationScalar);
            ry = Math.sin((this.internalFrameCountY - this.oscillationYFrameCount - this.index * 10) / 20.0) * (this.oscillationYValue * oscillationScalar);

        }

        // rx = Math.sin((this.internalFrameCountX - this.oscillationXFrameCount) * this.oscillationXValue * oscillationScalar);

        this.updatePosition(rx, ry);


    }

    updateFillColor(fill) {

        this.fillColor = fill;
    }

    resetFillColor() {

        this.fillColor = p5.color("#DDDDDD");
    }

    updateOpacity(o) {
        this.opacity = o;
    }

    updateSize(s) {
        this.circleSize = s;

        this.sx = s;
        this.sy = s;
    }

    updateOscillationX(x) {

        this.oscillationXValue = x;

    }

    updateOscillationY(y) {

        this.oscillationYValue = y;

    }

    renderAtPosition(mx, my) {

        let s = this.sketch;
        this.updateInternalFrameCount();

        s.push();
        s.noStroke();
        s.fill(this.fillColor, this.opacity);
        s.ellipse(mx, my, this.sx, this.sy);
        s.pop();

    }

    render() {

        let s = this.sketch;
        this.updateInternalFrameCount();

        s.push();
        s.noStroke();
        s.fill(this.fillColor, this.opacity);
        s.ellipse(this.cx, this.cy, this.sx, this.sy);
        s.pop();



    }


}

export default Particle;